import actions from "./actions";
import mutations from "./mutations";
import state from "./state";

const getters = {
  getFDTeacherList: (state) => state.items,
  getFDTeacherListPagination: (state) => state.pagination,
  getFDTeacherListPage: (state) => state.pagination.current_page,
};
export default {
  state,
  actions,
  mutations,
  getters,
};
